// Add this code inside the <head> tag in your theme.liquid file or as a separate JS file

document.addEventListener("DOMContentLoaded", function() {
    // Array of fake sales data
    const fakeSales = [
        { name: 'Jessica', location: 'Texas', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Emily', location: 'California', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Sarah', location: 'Illinois', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Olivia', location: 'Colorado', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Beatrice', location: 'Virginia', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Mia', location: 'Texas', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Sophia', location: 'California', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Charlotte', location: 'New Jersey', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Amelia', location: 'Colorado', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Adriana', location: 'Kansas', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Gloria', location: 'Michigan', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Lily', location: 'Kentucky', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Ava', location: 'Alabama', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Chloe', location: 'New Orleans', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Kloe', location: 'Utah', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Brooke', location: 'Florida', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Macy', location: 'Texas', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Heather', location: 'Indiana', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Georgia', location: 'Florida', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Grace', location: 'Maine', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Veronica', location: 'New York', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Ruby', location: 'Oregon', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Jin', location: 'Washington', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Li-Ann', location: 'California', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Annabelle', location: 'Florida', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Shannon', location: 'North Carolina', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Nina', location: 'Oklahoma', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Miyu', location: 'Connecticut', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Ella', location: 'Michigan', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Adrienne', location: 'Indiana', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Charvi', location: 'New Jersey', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Vaishnavi', location: 'New York', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Ananya', location: 'California', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Valentina', location: 'Maryland', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Mia', location: 'New Mexico', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Abigail', location: 'Iowa', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Zola', location: 'Arizona', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Leila', location: 'California', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Simone', location: 'New York', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Sandra', location: 'Nevada', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Lúcia', location: 'Wisconsin', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Sofia', location: 'Nevada', product: 'Blossom Maternity Bra', color: 'White' }
    ];

    // Function to show the fake notification
    function showFakeNotification() {
        const sale = fakeSales[Math.floor(Math.random() * fakeSales.length)];
        const message = `${sale.name} from ${sale.location} just bought a ${sale.product} in ${sale.color}!`;

        const notification = document.createElement('div');
        notification.className = 'fake-sale-notification';
        notification.innerHTML = message;

        // Style for the notification
        notification.style.position = 'fixed';
        notification.style.bottom = '20px';
        notification.style.left = '50%';
        notification.style.transform = 'translateX(-50%)';
        notification.style.backgroundColor = 'rgba(223, 147, 231, 0.61)';
        notification.style.color = '#fff';
        notification.style.padding = '10px 20px';
        notification.style.borderRadius = '5px';
        notification.style.fontSize = '14px';
        notification.style.zIndex = '9999';
        notification.style.animation = 'slide-up 1s ease-in-out';

        // Append notification to the body
        document.body.appendChild(notification);

        // Remove notification after 7 seconds
        setTimeout(function() {
            notification.remove();
        }, 7000);
    }

    // Trigger the fake notifications every 10-15 seconds
    setInterval(showFakeNotification, Math.random() * (100000 - 10000) + 10000);  // Random interval between 10 to 15 seconds
});
